<template>
  <span v-if="this.$route.params.jenis=='TMA'">
  <DataPetugasTMAVue/>
  </span>
  <span v-else>
  <DataPetugasOmbroVue/>
  </span>
</template>

<script>
import DataPetugasTMAVue from './DataPetugasTMA.vue'
import DataPetugasOmbroVue from './DataPetugasOmbro.vue'

  export default {
    name: 'Data Petugas',
    data: () => ({
    }),
    components: {
      DataPetugasTMAVue,
      DataPetugasOmbroVue
    }
  }
</script>